import { render, staticRenderFns } from "./ArchiveStore.vue?vue&type=template&id=00a056b0"
import script from "./ArchiveStore.vue?vue&type=script&lang=ts"
export * from "./ArchiveStore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports